// Configuration and State Management

export const config = {
    stripeKey: '',
    turnstileSiteKey: '',
    apiBaseUrl: '',
    editions: {
        1: { name: 'Starter', annualPrice: 299, monthlyPrice: 35 },
        2: { name: 'Professional', annualPrice: 749, monthlyPrice: 89, baseSeats: 5, maxSeats: 10 }
    },
    extraSeatPrice: {
        annual: 120,
        monthly: 10
    },
    ui: {
        animationDuration: 1500,
        toastTimeout: 5000,
        cookieBannerDelay: 1000,
        debounceDelay: 300
    }
};

// Mutable state
export const state = {
    stripe: null,
    isAnnualBilling: true,
    selectedEdition: null,
    downloadTurnstileWidgetId: null,
    enterpriseTurnstileWidgetId: null,
    checkoutTurnstileWidgetId: null,
    extraSeats: 0,
    stripeRetryCount: 0,
    previouslyFocusedElement: null,
    mobileMenuPreviousFocus: null,
    mobileMenuFocusTrapHandler: null,
    particleAnimationId: null
};

export const MAX_STRIPE_RETRIES = 10;

// Load configuration from server
export async function loadConfig() {
    try {
        const response = await fetch('/stripe/config');
        if (response.ok) {
            const data = await response.json();
            config.stripeKey = data.publishableKey;
            config.turnstileSiteKey = data.turnstileSiteKey || '';

            if (data.prices) {
                applyDynamicPrices(data.prices);
            }
        }
    } catch (error) {
        console.error('Failed to load config:', error);
    }
}

function applyDynamicPrices(prices) {
    if (prices.StarterAnnual) {
        config.editions[1].annualPrice = prices.StarterAnnual.amount;
    }
    if (prices.StarterMonthly) {
        config.editions[1].monthlyPrice = prices.StarterMonthly.amount;
    }
    if (prices.ProfessionalAnnual) {
        config.editions[2].annualPrice = prices.ProfessionalAnnual.amount;
    }
    if (prices.ProfessionalMonthly) {
        config.editions[2].monthlyPrice = prices.ProfessionalMonthly.amount;
    }

    const starterCard = document.querySelector('.pricing-card[data-edition="starter"]');
    const professionalCard = document.querySelector('.pricing-card[data-edition="professional"]');

    updatePriceCard(starterCard, config.editions[1].annualPrice, config.editions[1].monthlyPrice);
    updatePriceCard(professionalCard, config.editions[2].annualPrice, config.editions[2].monthlyPrice);
}

function updatePriceCard(card, annual, monthly) {
    if (!card) return;
    const priceEl = card.querySelector('.price-amount[data-annual]');
    if (priceEl) {
        priceEl.dataset.annual = annual;
        priceEl.dataset.monthly = monthly;
        // Skip Professional - it's handled by updateProfessionalPrice() in pricing.js
        // which accounts for extra seats
        if (priceEl.id !== 'professionalPrice') {
            priceEl.textContent = state.isAnnualBilling ? annual : monthly;
        }
    }
}
